import compass from "../../images/compass.png";

export default function Compass({ compassRef, restoreRotation }) {
  return (
    <img
      ref={compassRef}
      alt="compass"
      className="prevent-select"
      src={compass}
      onClick={restoreRotation}
      style={{
        position: "absolute",
        top: 10,
        right: 7,
        zIndex: 100,
        width: 80,
        height: "auto",
      }}
    />
  );
}
